import { Grid } from '@mui/material';
import { EditCardSkeleton } from '../edit-card/EditCardSkeleton';

export interface VideoEditionsEditGridSkeletonProps {
  /** Number of placeholder cards (defaults to a responsive grid-friendly count). */
  count?: number;
}

/**
 * Responsive grid of {@link EditCardSkeleton} items, matching {@link VideoEditionsEditGrid} spacing.
 */
export function VideoEditionsEditGridSkeleton({ count = 6 }: VideoEditionsEditGridSkeletonProps) {
  return (
    <Grid container spacing={2}>
      {Array.from({ length: count }, (_, index) => (
        <EditCardSkeleton key={index} />
      ))}
    </Grid>
  );
}
